export default "__VITE_ASSET__CvHBZrJM__"